import { Form, Input, Select, Button, Space, message, Modal, Divider } from "antd";
import { CloseOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import axios from "axios";
import ClienteForm from "./ClienteForm";

export default function AddVerificationForm(props) {
  const { setVerifications, visible, setVisible, setLoading } = props;
  const [form] = Form.useForm();
  const [clientes, setClientes] = useState();
  const [clienteFormVisible, setClienteFormVisible] = useState(false);
  const [clienteEditing, setClienteEditing] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(false);

  useEffect(() => {
    visible && form.resetFields();
    axios
      .get(`${process.env.REACT_APP_API_URL}/clientes`)
      .then((res) => {
        setClientes(res.data);
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al cargar los clientes");
      });
  }, [visible, form]);

  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        setLoading(true);
        axios
          .post(`${process.env.REACT_APP_API_URL}/verificaciones`, {
            ...values,
            FechaCreacion: new Date(),
            UvieID: 1,
          })
          .then((res) => {
            setLoading(false);
            setVisible(false);
            message.success("Verificación agregada");
            axios
              .get(`${process.env.REACT_APP_API_URL}/verificaciones`)
              .then((res) => {
                setVerifications(res.data);
                message.success("Lista de verificaciones actualizada");
              })
              .catch((err) => {
                setLoading(false);
                console.log("Error al obtener las verificaciones", err);
                message.error("Error al obtener las verificaciones");
              });
          })
          .catch((err) => {
            setLoading(false);
            console.log("Error al agregar la verificación", err);
            message.error("Error al agregar la verificación");
          });
      })
      .catch((err) => {
        console.log(err);
        message.error("Error al validar los campos");
      });
  };

  const clearSelectProps = {
    style: { width: "100%" },
    allowClear: true,
    clearIcon: <CloseOutlined style={{ color: "red" }} />,
    showSearch: true,
    filterOption: (input, option) => option.children?.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0,
  };

  return (
    <>
      <Modal title="Crear verificación" visible={visible} onCancel={() => setVisible(false)} footer={null} width={800}>
        <Form form={form} layout="vertical">
          <Form.Item name="DescripcionBreve" label="Descripción" rules={[{ required: true, message: "Escriba la descripción" }]}>
            <Input placeholder="Describa la verificación brevemente" />
          </Form.Item>
          <Form.Item name="ClienteID" label="Cliente" rules={[{ required: true, message: "Seleccione el cliente" }]}>
            <Select
              placeholder="Seleccione un cliente"
              {...clearSelectProps}
              open={openDropdown}
              onDropdownVisibleChange={(visibility) => setOpenDropdown(visibility)}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <div style={{ float: "right" }}>
                    <Divider style={{ margin: "4px 0" }} />
                    <Space direction="horizontal">
                      <Button
                        icon={<EditOutlined />}
                        onClick={() => {
                          const currentCliente = form.getFieldValue("ClienteID");
                          if (currentCliente) {
                            setClienteEditing(currentCliente);
                            setOpenDropdown(false);
                            setTimeout(() => {
                              setClienteFormVisible(true);
                            }, 250);
                          } else {
                            message.warn("Seleccione un cliente para editar");
                          }
                        }}
                      >
                        Editar cliente
                      </Button>
                      <Button
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setClienteEditing(null);
                          setOpenDropdown(false);
                          setTimeout(() => {
                            setClienteFormVisible(true);
                          }, 250);
                        }}
                      >
                        Agregar cliente
                      </Button>
                    </Space>
                  </div>
                </>
              )}
            >
              {clientes &&
                clientes.map((cliente) => (
                  <Select.Option key={cliente.ClienteID} value={cliente.ClienteID}>
                    {cliente.NombreCliente}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
        </Form>
        <Space>
          <Button
            type="primary"
            onClick={() => {
              onSubmit();
            }}
          >
            Agregar
          </Button>
          <Button
            type="primary"
            onClick={() => {
              setVisible(false);
              form.resetFields();
            }}
          >
            Cancelar
          </Button>
        </Space>
      </Modal>
      <ClienteForm
        visible={clienteFormVisible}
        setVisible={setClienteFormVisible}
        setClientes={setClientes}
        cliente={clienteEditing}
        onSuccess={(id) => {
          form.setFieldsValue({ ClienteID: id });
          setClienteFormVisible(false);
        }}
      />
    </>
  );
}
